// src/utils/teamInfo.js
const TEAM_INFO = {
  ADEL: { id: 1, logoKey: "Adelaide", fullName: "Adelaide Crows" },
  BRIS: { id: 2, logoKey: "Brisbane Lions", fullName: "Brisbane Lions" },
  CARL: { id: 3, logoKey: "Carlton", fullName: "Carlton Blues" },
  COLL: { id: 4, logoKey: "Collingwood", fullName: "Collingwood Magpies" },
  ESS: { id: 5, logoKey: "Essendon", fullName: "Essendon Bombers" },
  FREM: { id: 6, logoKey: "Fremantle", fullName: "Fremantle Dockers" },
  GEEL: { id: 7, logoKey: "Geelong", fullName: "Geelong Cats" },
  GC: { id: 8, logoKey: "Gold Coast", fullName: "Gold Coast Suns" },
  GWS: { id: 9, logoKey: "Greater Western Sydney", fullName: "GWS Giants" },
  HAW: { id: 10, logoKey: "Hawthorn", fullName: "Hawthorn Hawks" },
  MELB: { id: 11, logoKey: "Melbourne", fullName: "Melbourne Demons" },
  NM: {
    id: 12,
    logoKey: "North Melbourne",
    fullName: "North Melbourne Kangaroos",
  },
  PORT: { id: 13, logoKey: "Port Adelaide", fullName: "Port Adelaide Power" },
  RICH: { id: 14, logoKey: "Richmond", fullName: "Richmond Tigers" },
  STK: { id: 15, logoKey: "St Kilda", fullName: "St Kilda Saints" },
  SYD: { id: 16, logoKey: "Sydney", fullName: "Sydney Swans" },
  WCE: { id: 17, logoKey: "West Coast", fullName: "West Coast Eagles" },
  WB: { id: 18, logoKey: "Western Bulldogs", fullName: "Western Bulldogs" },
};

export default TEAM_INFO;
